// Puck custom field: pick an image from the Media Center (real filesApi).
// Bound value is the file's servable URL string (persisted straight into the
// block prop). Renders in Puck's right-hand fields panel (parent document), so
// the MediaPicker modal behaves normally.

import { useState } from 'react';
import { Button } from 'antd';
import { Image as ImageIcon, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { MediaPicker } from '@shared/components/MediaPicker';
import { resolveAssetUrl } from '@shared/utils/assetUrl';

interface BuilderMediaFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function BuilderMediaField({ value, onChange }: BuilderMediaFieldProps) {
  const { t } = useTranslation('pages');
  const [open, setOpen] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {value ? (
        <div
          style={{
            position: 'relative',
            border: '1px solid var(--ds-border, #e5e7eb)',
            borderRadius: 8,
            overflow: 'hidden',
          }}
        >
          <img
            src={resolveAssetUrl(value)}
            alt=""
            style={{ width: '100%', height: 120, objectFit: 'cover', display: 'block' }}
          />
          <Button
            type="text"
            danger
            size="small"
            icon={<X size={14} />}
            onClick={() => onChange('')}
            aria-label={t('builder.fields.removeImage')}
            style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(255,255,255,0.85)' }}
          />
        </div>
      ) : null}
      <Button block icon={<ImageIcon size={14} />} onClick={() => setOpen(true)}>
        {value ? t('builder.fields.changeImage') : t('builder.fields.pickImage')}
      </Button>
      <MediaPicker
        open={open}
        onClose={() => setOpen(false)}
        onSelect={(item) => {
          onChange(item.url);
          setOpen(false);
        }}
      />
    </div>
  );
}
